/**
 * Created by Bart Decorte
 * Date: 06/07/2020
 * Time: 10:55
 */
import Toast from './Toast';

export default class DangerToast extends Toast {
  constructor(body, header) {
    super(body, header);
    this.ariaLive = 'assertive';
  }

  iconMarkup() {
    return `
      <span class="text-danger mr-2">
        <i class="fe fe-alert-triangle"></i>
      </span>
    `
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/toasts/DangerToast.js